// extracted by mini-css-extract-plugin
export default {"prompt":"TerminalPrompt_prompt__vTBV3","ps1":"TerminalPrompt_ps1__Y0Hht"};